import { PlayUnifiedLiveEpgQuery } from '../modules/dataProviders/__generated__/Epg';
import { findCurrentProgram } from '../modules/helpers/findProgram';

export function getCurrentProgramOrSubprogram(liveEpgResult: PlayUnifiedLiveEpgQuery | undefined) {
  const program =
    // eslint-disable-next-line no-underscore-dangle
    liveEpgResult?.entity?.__typename === 'Broadcast' &&
    findCurrentProgram(liveEpgResult?.entity.epgEntries?.nodes);
  const subprogram =
    (program &&
      // eslint-disable-next-line no-underscore-dangle
      program?.__typename === 'Epg' &&
      findCurrentProgram(program?.subPrograms)) ??
    program;
  return subprogram;
}
